import ReactGA from 'react-ga';

//  https://developers.google.com/analytics/devguides/collection/gtagjs/events

// gtag('event', 'aaa', {
//   'event_category' : 'bbb',
//   'event_label' : 'ccc'
// });

/**
 * registerAnalyticsEvent( {category: 'social', action: 'click', value: {}, label: 'twitter'} )
 * category required
 * action required
 */
export const registerAnalyticsEvent = ({category, action, value, label}) => {
    if (process.env.NODE_ENV !== 'production') return;
    try {
        // window?.trackingFn('event', action, {
        //     'event_category': category,
        //     'event_label': label
        // });

        ReactGA.event({category, action, value, label});
    } catch (e) {

    }
}

export const registerAnalyticsPage = (page) => {
    if (process.env.NODE_ENV !== 'production') return;
    ReactGA.pageview(page);
}
